const projectPage = {
  loading: "Loading project...",
  errorTitle: "Error Loading Project",
  errors: {
    failedToLoadProject: "Failed to load project",
    downloadFailed: "Download failed",
    failedToRemoveUser: "Failed to remove user",
    failedToChangeArchiveState: "Failed to change archive state",
    failedToDisable2FA: "Failed to disable 2FA",
    failedToRevokeInvitation: "Failed to revoke invitation",
  },
  alerts: {
    unenrolled: "You have been unenrolled from this project.",
  },
  confirm: {
    revokeInvitation: "Revoke this invitation?",
  },
  header: {
    backToProjects: "Back to projects",
  },
  badges: {
    viewOnly: "View Only",
    archived: "Archived",
    active: "Active",
    inactive: "Inactive",
  },
  archivedNote: {
    text: "This project is inactive, therefore it is in a read-only state.",
    restoreLink: "Restore it in Settings",
  },
  meta: {
    organizationId: "Organization ID",
    yourRole: "Your role",
    managerViewOnly: "Manager (view only)",
  },
  tabs: {
    overview: "Overview",
    members: "Members",
    datasets: "Datasets",
    requests: "Data Requests",
  },
  overview: {
    teamMembers: "Team members",
    datasets: "Datasets",
    dataRequests: "Data requests",
    fulfilled: "fulfilled",
    needsAttention: "Needs your attention",
    allReviewed: "Nothing pending — all requests reviewed",
    requestedOn: "Requested {{date}}",
    review: "Review",
  },
  members: {
    createdBy: "Created by",
    you: "You",
    formerMember: "a member no longer on this project",
    noMembers: "No members assigned to this project",
  },
  datasets: {
    title: "Project Datasets",
    subtitle: "Datasets uploaded to or approved for this project",
    uploadButton: "Upload dataset",
    uploadPanelTitle: "Upload Dataset to Project",
    uploadPanelSubtitle: "Upload and de-identify data files for this project",
    uploadSuccess: "File uploaded successfully.",
  },
  requests: {
    title: "Project Data Requests",
    newRequest: "New Request",
  },
};

export default projectPage;
